import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';
import { StatusCodes } from 'http-status-codes';

import logger from 'logger';
import ApiService from 'services/ApiService/ApiService';
import { getDomain, generateQueryFromObject } from 'utils/helpers';
import { actionCreators as appStateActions } from 'app/AppState';

import {
  FANCLUB_PRIVATE_TIPPING_URL,
  TIPPING_POLLING_URL,
  TIPPING_OPERATION_URL,
  PRIVATE_TIPPING_URL,
} from './Api';


const SET_SESSION_ID = 'cam4/profilevideo/SET_SESSION_ID';
const SET_TIPPING_INFO = 'cam4/profilevideo/SET_TIPPING_INFO';
const SET_GOAL_INFO = 'cam4/profilevideo/SET_GOAL_INFO';

const initialState = Immutable.fromJS({
  status: '',
  goalbalance: '',
  goal: '',
  sessionId: '',
  deadline: '',
  message: '',
  messagetime: '',
  userbalance: '',
  crtbalance: '',
  topTipper: '',
  toptipper: '',
  tlamount: '',
  'last_id': '',
  topTipperSelf: '',
  f: '',
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SESSION_ID:
      return state.set('sessionId', action.sessionId);
    case SET_GOAL_INFO:
      return state.set('goal', action.goal).set('goalbalance', action.goalbalance).set('message', action.message);
    case SET_TIPPING_INFO:
      return state
        .set('status', action.data.status)
        .set('deadline', action.data.deadline)
        .set('messageTime', action.data.messageTime)
        .set('userbalance', action.data.userbalance)
        .set('crtbalance', action.data.crtbalance)
        .set('topTipper', action.data.topTipper)
        .set('toptipper', action.data.toptipper)
        .set('tlamount', action.data.tlamount)
        .set('last_id', action.data.last_id)
        .set('topTipperSelf', action.data.topTipperSelf)
        .set('f', action.data.f);
    default:
      return state;
  }
}

export const NAME = 'tippingInfo';

const tippingInfo = (state) => state[NAME];
const sessionId = (state) => state[NAME].get('session_id');
const goal = (state) => state[NAME].get('goal');
const goalbalance = (state) => state[NAME].get('goalbalance');
const message = (state) => state[NAME].get('message');

export function placeholder() {
  return null;
}

function populateSessionId(sessionId) {
  return {
    type: SET_SESSION_ID,
    sessionId,
  };
}

function populateGoalValues(goal, goalbalance, message) {
  return {
    type: SET_GOAL_INFO,
    goal,
    goalbalance,
    message,
  };
}

function populateTippingInfo(data) {
  return {
    type: SET_TIPPING_INFO,
    data,
  };
}

export function getTippinginfo(username, roomName, user, sessionId = null) {
  const { accessHash } = user;
  const domain = getDomain();
  const params = {
    operation: 'getUserSession',
    'session_id': sessionId || '',
    'model_id': roomName,
    'user_id': username,
    key: accessHash,
    lang: 'en',
    domain,
  };

  const url = `${TIPPING_POLLING_URL}?params=${JSON.stringify(params)}`;

  return (dispatch) =>
    ApiService.get(url, { withCredentials: false })
      .then((res) => {
        if (res.status === StatusCodes.OK && res.data.session_id) {
          dispatch(populateSessionId(res.data.session_id));
          dispatch(populateGoalValues(res.data.goal, res.data.goalbalance, decodeURIComponent(res.data.message)));
          dispatch(populateTippingInfo(res.data));
        }
      })
      .catch((error) => logger.error(error));
}

export function sendTip(data) {
  const parsedURL = encodeURI(`${TIPPING_OPERATION_URL}${generateQueryFromObject(data)}`);

  return (dispatch) =>
    ApiService.post(parsedURL)
      .then((res) => {
        if (res.data.status !== '0') {
          logger.error(`Error while sending tip. Status:, error: ${res.data.response}`);
        }

        if (res.status === StatusCodes.OK && res.data.userbalance) {
          dispatch(appStateActions.updateBalance(res.data.userbalance));
        }

        return res;
      })
      .catch((error) => logger.error(error));
}

export function sendPrivateTip(data) {
  const { isFanClubPrivateTip } = data || false;
  const privateTippingURL = isFanClubPrivateTip ? FANCLUB_PRIVATE_TIPPING_URL : PRIVATE_TIPPING_URL;
  const parsedURL = encodeURI(privateTippingURL.replace('{username}', data.receiver));
  const postData = isFanClubPrivateTip ? { amount: data.tipAmount } : {
    amount: data.tipAmount,
    message: data.message,
  };

  return (dispatch) =>
    ApiService.post(parsedURL, { data: postData })
      .then((res) => {
        if (res.status === StatusCodes.OK && res.data.userbalance) {
          dispatch(appStateActions.updateBalance(res.data.userbalance));
        }

        return res;
      })
      .catch((error) => logger.error(error));
}

export const selector = createStructuredSelector({
  tippingInfo,
  sessionId,
  tippingInfoData: createStructuredSelector({
    goal,
    goalbalance,
    message,
  }),
});

export const actionCreators = {
  placeholder,
  getTippinginfo,
  sendTip,
  sendPrivateTip,
};
